/**
 * Código de indicação (Indique e ganhe, docs/features/referral/README.md)
 *
 * Quem abre o site por `/i/CODIGO` guarda o código aqui por 60 dias; o cadastro
 * (RegisterAPI) manda o código junto e o backend grava quem indicou quando a conta
 * nasce. Não depende do consentimento de cookies: é a execução do programa de
 * indicação (quem indicou recebe o crédito), não medição de marketing.
 */

export const REFERRAL_CODE_KEY = 'gabriela_referral_code';
const MAX_AGE_MS = 60 * 24 * 60 * 60 * 1000;

/**
 * Só letras e números, maiúsculo, de 4 a 12 caracteres (mesma regra do backend).
 * @param {string} raw
 * @returns {string|null}
 */
export function normalizeReferralCode(raw) {
  const code = String(raw || '').replace(/[^A-Za-z0-9]/g, '').toUpperCase();
  return code.length >= 4 && code.length <= 12 ? code : null;
}

/**
 * @param {string} raw
 * @returns {string|null} o código guardado, ou null se não valia
 */
export function storeReferralCode(raw) {
  const code = normalizeReferralCode(raw);
  if (!code) return null;
  try {
    localStorage.setItem(REFERRAL_CODE_KEY, JSON.stringify({ code, at: Date.now() }));
  } catch (e) {
    // localStorage indisponível: a pessoa ainda consegue se cadastrar, só sem o código
  }
  return code;
}

/** @returns {string|null} */
export function getReferralCode() {
  try {
    const raw = localStorage.getItem(REFERRAL_CODE_KEY);
    if (!raw) return null;
    const saved = JSON.parse(raw);
    if (!saved || !saved.code || Date.now() - Number(saved.at || 0) > MAX_AGE_MS) {
      clearReferralCode();
      return null;
    }
    return normalizeReferralCode(saved.code);
  } catch (e) {
    return null;
  }
}

export function clearReferralCode() {
  try {
    localStorage.removeItem(REFERRAL_CODE_KEY);
  } catch (e) {
    // nada a fazer
  }
}
